const app = (state = {}, action) => {
    switch (action.type) {
        case 'CATALOG_SETPARAMS': {
            const payload = action.payload;

            return {
                ...state,
                ...payload,
            };
        }

        case 'CATALOG_LOADED': {
            const payload = action.payload;

            return {
                ...state,
                ...payload,
            };
        }

        case 'CATALOG_REPORT_LOADING': {
            return {
                ...state,
                reportLoading: action.payload,
            };
        }

        case 'CATALOG_SETCATEGORIES': {
            return {
                ...state,
                breadcrumbs: action.payload.breadcrumbs,
                currentCategories: action.payload.currentCategories,
            };
        }

        default: {
            return state;
        }
    }
};

export default app;
